var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center d-flex justify-center align-self-center flex-column py-16"},[_c('v-progress-circular',{staticClass:"mb-6 mx-auto",attrs:{"indeterminate":"","size":"100","color":"primary"}}),_c('br'),_c('span',[_vm._v("Carregando...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }